module.exports = __webpack_public_path__ + "static/media/Asset 4_6.d50b3454.png";